export const LOCALES = {
  ENGLISH: "EN",  
  ITALIAN: "IT-IT",
  TURKISH: "TR-TR",
  GERMAN: "DE-DE",
  POLISH: "PL-PL",
  JAPANESE: "JA-JP",
  SPANISHLATIN: "ES-MX",
  PORTUGESE: "PT-BR",
  CHINESETRADITIONAL: "ZH-TW",
  SPANISH: "ES-ES",
  RUSSIAN: "RU-RU",
  CHINESESIMPLIFIED: "ZH-CN",
  FRENCH: "FR-FR",
  CZECH: "CZ-CZ",
  KOREAN: "KO-KO",
};

export const languageList = [
  {
    id: 1,
    name: "English",
    locale: LOCALES.ENGLISH,
    isSelected: false,
    isVisible: true,
  },
  {
    id: 2,
    name: "Italiano",
    locale: LOCALES.ITALIAN,
    isSelected: false,
    isVisible: true,
  },
  {
    id: 3,
    name: "Türkçe",
    locale: LOCALES.TURKISH,
    isSelected: false,
    isVisible: false,
  },
  {
    id: 4,
    name: "Deutsch",
    locale: LOCALES.GERMAN,
    isSelected: false,
    isVisible: true,
  },
  {
    id: 5,
    name: "Polski",
    locale: LOCALES.POLISH,
    isSelected: false,
    isVisible: false,
  },
  {
    id: 6,
    name: "日本語",
    locale: LOCALES.JAPANESE,
    isSelected: false,
    isVisible: true,
  },
  {
    id: 7,
    // name: "Español (LATINOAMÉRICA)",
    name: "Español",
    locale: LOCALES.SPANISHLATIN,
    isSelected: false,
    isVisible: true,
  },
  {
    id: 8,
    name: "Português",
    locale: LOCALES.PORTUGESE,
    isSelected: false,
    isVisible: true,
  },
  {
    id: 9,
    name: "中文 (繁體)",
    locale: LOCALES.CHINESETRADITIONAL,
    isSelected: false,
    isVisible: false,
  },
  {
    id: 10,
    name: "Español (España)",
    locale: LOCALES.SPANISH,
    isSelected: false,
    isVisible: false,
  },

  {
    id: 11,
    name: "Русский",
    locale: LOCALES.RUSSIAN,
    isSelected: false,
    isVisible: false,
  },
  {
    id: 12,
    name: "中文(简体)",
    locale: LOCALES.CHINESESIMPLIFIED,
    isSelected: false,
    isVisible: true,
  },
  {
    id: 13,
    name: "Français",
    locale: LOCALES.FRENCH,
    isSelected: false,
    isVisible: true,
  },
  {
    id: 14,
    name: "Česky",
    locale: LOCALES.CZECH,
    isSelected: false,
    isVisible: false,
  },
  {
    id: 15,
    name: "한국어",
    locale: LOCALES.KOREAN,
    isSelected: false,
    isVisible: false,
  },
];
